import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-l01" }
const _hoisted_5 = {
  key: 0,
  class: "p-the-l01-news-list__count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_TheL01NewsList = _resolveComponent("TheL01NewsList")!
  const _component_TheL01EmptyPanel = _resolveComponent("TheL01EmptyPanel")!
  const _component_TheTemplateL = _resolveComponent("TheTemplateL")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
          : (_openBlock(), _createBlock(_component_TheTemplateL, {
              key: 1,
              search: _ctx.search,
              "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              heading: "お知らせ一覧",
              "indicated-item": ['search', 'sorted', 'searchButton'],
              "search-keyword": _ctx.searchKeyword,
              sorted: _ctx.sorted,
              "filter-heading": _ctx.filterHeading,
              error: _ctx.error,
              onDoSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doSearch($event, 1))),
              onDoSort: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doSort($event)))
            }, {
              contents: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.showSearchCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.searchCount) + "記事", 1))
                    : _createCommentVNode("", true),
                  (_ctx.newsListExists)
                    ? (_openBlock(), _createBlock(_component_TheL01NewsList, {
                        key: 1,
                        "news-list": _ctx.newsList,
                        slug: _ctx.slug,
                        "page-navi": _ctx.pageNavi,
                        "search-keyword": _ctx.searchKeyword
                      }, null, 8, ["news-list", "slug", "page-navi", "search-keyword"]))
                    : _createCommentVNode("", true),
                  (_ctx.showNotFound)
                    ? (_openBlock(), _createBlock(_component_TheL01EmptyPanel, {
                        key: 2,
                        "search-keyword": _ctx.searchKeyword
                      }, null, 8, ["search-keyword"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["search", "search-keyword", "sorted", "filter-heading", "error"]))
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}